import { useRef, useState } from 'react';
import { Box, LinearProgress, Link, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { UPLOAD_ACCEPT } from '../../../lib/packingListUpload';

/**
 * 실무자가 PL 파일을 끌어다 놓거나 클릭해 고르는 입구. 기존 문서 업로드 다이얼로그와 같은 모양으로 둔다.
 * 받는 형식·크기는 서버 규칙(packingListUpload)과 같다. 올리는 동안은 진행률을 보여주고 다른 파일을 받지 않는다.
 */
export default function FileDropzone({ onFile, disabled, compact, uploading = false, progress = 0, filename = '' }) {
    const inputRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const blocked = disabled || uploading;
    const pick = (files) => {
        const file = files?.[0];
        if (file && !blocked) onFile(file);
    };
    return (
        <Box
            onDragOver={(e) => { e.preventDefault(); if (!blocked) setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={(e) => { e.preventDefault(); setDragging(false); pick(e.dataTransfer.files); }}
            sx={{ py: compact ? 1.5 : 3, px: 1, border: '2px dashed', borderColor: dragging ? 'primary.main' : 'divider', borderRadius: 2, bgcolor: dragging ? 'action.hover' : 'background.default', textAlign: 'center', opacity: disabled ? 0.5 : 1 }}
        >
            <input ref={inputRef} type="file" accept={UPLOAD_ACCEPT} aria-label="Packing list file" hidden disabled={blocked} onChange={(e) => { pick(e.target.files); e.target.value = ''; }} />
            <UploadFileIcon sx={{ fontSize: compact ? 32 : 48, color: 'text.secondary' }} />
            {uploading ? (
                <Box sx={{ px: compact ? 2 : 6, mt: 0.5 }}>
                    <Typography variant="body2" color="text.secondary" noWrap title={filename}>Uploading <b>{filename}</b>… {progress}%</Typography>
                    <LinearProgress variant={progress > 0 && progress < 100 ? 'determinate' : 'indeterminate'} value={progress} sx={{ mt: 1, height: 6, borderRadius: 3 }} />
                </Box>
            ) : (
                <>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        <b>Drop a Packing List here</b> or{' '}
                        <Link component="button" type="button" disabled={blocked} onClick={() => !blocked && inputRef.current?.click()} sx={{ fontSize: 'inherit', verticalAlign: 'baseline' }}>browse</Link>
                    </Typography>
                    <Typography variant="caption" color="text.secondary">PDF, Excel (.xlsx, .xls), PNG or JPG up to 15 MB. Parsed lines can be reviewed before confirming.</Typography>
                </>
            )}
        </Box>
    );
}
